// import { json } from '@codemirror/lang-json';
// import CodeMirror from '@uiw/react-codemirror';

/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */

import FalconCardHeader from 'components/common/FalconCardHeader';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Card, Form, Table } from 'react-bootstrap';

/***
 * Component showing sql query results as a table
 * Converts sql results json to a table format
 */
function QueryResultsTable(queryResult) {
  if (queryResult.length == 0) return;

  var keys = Object.keys(queryResult[0]);

  var tableHeaders = [];
  var tableRows = [];

  console.log('keys', keys);
  for (let i = 0; i < keys.length; i++) {
    //console.log('headings', heading);
    tableHeaders.push(<th scope="col">{keys[i]}</th>);
  }

  for (let i = 0; i < queryResult.length; i++) {
    let o = queryResult[i];
    // let row = [];
    let cols = [];

    for (let k = 0; k < keys.length; k++) {
      let key = keys[k];
      cols.push(<td scope="col">{o[key]}</td>);
    }

    tableRows.push(<tr>{cols}</tr>);
  }

  console.log(tableHeaders);

  return (
    <Table size="sm" responsive striped bordered>
      <thead>
        <tr>{tableHeaders}</tr>
      </thead>
      <tbody>{tableRows}</tbody>
    </Table>
  );
}

function QueryResultsJson(queryResult) {
  return (<>
    <textarea>{JSON.stringify(queryResult, null, ' ')}</textarea>
  </>
    // <CodeMirror
    //   basicSetup={{ lineNumbers: true }}
    //   value={JSON.stringify(queryResult, null, ' ')}
    //   minHeight="300px"
    //   maxHeight="600px"
    //   theme="dark"
    //   extensions={[json()]}
    //   readOnly
    // />
  );
}
export default function SQLQueryResult(props) {
  const [selectedViewMode, setSelectedViewMode] = useState('table');

  return (
    <Card className="p-0">
      <FalconCardHeader
        title="Query Results"
        light
        titleTag="h6"
        endEl={
          <Form.Select
            value={selectedViewMode}
            onChange={e => setSelectedViewMode(e.target.value)}
          >
            <option value="table">Table</option>
            <option value="json">JSON</option>
          </Form.Select>
        }
      />

      <Card.Body className="p-0" style={{ minHeight: '200px' }}>
        {selectedViewMode == 'table'
          ? QueryResultsTable(props.result)
          : QueryResultsJson(props.result)}
      </Card.Body>
    </Card>
  );
}

SQLQueryResult.propTypes = {
  result: PropTypes.array
};
